// Known combined height of Jet's header and category bar
export const PAGE_TOPSET = 163;

// Note: If you change the max width consider changing the base size of the product menu images
// Currently images are 540 wide (a bit wider than maxWidth / 3)
export const PAGE_MAX_WIDTH = 1500;

export const HOT_DEALS_CATEGORY_ID_PREFIX = "hotdeals";

// for stripe API
export const STRIPE_API_VERSION = "2023-10-16";
export const STRIPE_OPTIONS = {
  fonts: [
    {
      cssSrc:
        "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700",
    },
  ],
};
